export default {
  primary: '#10069F',
  secondary: '#495AD4',
  tertiary: '#8f73e9',
  accent: '#CAA2DD',
  error: '#495AD4',
  info: '#CAA2DD',
  success: '#AEB266',
  warning: '#E7CEB0',
  royal: '#10069F',
  active_blue: '#495AD4',
  lavender: '#CAA2DD',
  light_grey: '#C1C6C8',
  periwinkle: '#7978B7',
  light_purple: 'BCBFF0',
  purple: '#A773D7',
  dark_grey: '#5F5F5F',
  darker_grey: '#1F1F1F',
  oops: '#AA0000',
  yay: '#008800',
  sky: '#96AED9',
}
